import * as React from 'react';

const Filters16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.493 2.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v.777h7.758a.75.75 0 0 1 0 1.5H7.493V5.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-.723H.751a.75.75 0 1 1 0-1.5h2.742zm1.5 0v3h1v-3zM.751 10.276a.75.75 0 0 0 0 1.5h7.742v.724a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-.724h2.758a.75.75 0 0 0 0-1.5h-2.758V9.5a1.5 1.5 0 0 0-1.5-1.5h-1a1.5 1.5 0 0 0-1.5 1.5v.776zM10.993 9.5v3h-1v-3z"
  }
));
Filters16.Size = 16;
Filters16.Title = "Filters";

export { Filters16 as default };
